import performRequestBackend from "../../axios";

const loanTypeMap = {
  personal: "personal_loan",
  business: "business_loan",
  home: "home_loan",
};

const buildLoanPayload = (formData) => {
  const nameParts = formData.full_name.trim().split(/\s+/);
  const first_name = nameParts[0] || "";
  const last_name = nameParts.slice(1).join(" ") || "";

  return {
    first_name,
    last_name,
    email: formData.email,
    phone_number: formData.phone,
    type: loanTypeMap[formData.loan_type],
    consents_meta: {
      marketing_emails: true,
    },
    userinfo_meta: {
      pan_number: formData.pan_number,
      monthly_income: formData.monthly_income,
      required_amount: formData.loan_amount,
      employment_type: formData.employment_type,
      purpose: formData.purpose,
      preferred_language: "en",
      timezone: "UTC-5",
    },
    form_meta: {
      source: "web",
      campaign: "loans_page",
    },
  };
};

export const LoansApi = {
  submitLoanApplication: async (formData) => {
    const payload = buildLoanPayload(formData);
    const response = await performRequestBackend("/forms", "POST", payload);
    return response;
  },
  getLoanFormOptions: async (loanType) => {
    const response = await performRequestBackend(
      `/form-options/${loanTypeMap[loanType] || loanType}`,
      "GET"
    );
    return response;
  },
};
